import { ref } from 'vue';

import { useToastStore } from '@/stores/toast';
import { ProfileOption } from '@/types/components';

export function useFileInput() {
  const toastStore = useToastStore();

  const urlFilePreview = ref(''); // 이미지 미리보기 URL

  // 디폴트 이미지 목록O
  const listImageDefault: ProfileOption[] = [
    {
      id: 'headphone',
      label: 'headphone',
      type: 'image',
      src: '/images/logo-sconai.png',
    },
    {
      id: 'chocolate',
      label: 'chocolate',
      type: 'image',
      src: '/images/profiles/chocolate.webp',
    },
    {
      id: 'blueberry',
      label: 'blueberry',
      type: 'image',
      src: '/images/profiles/blueberry.webp',
    },
    {
      id: 'triangle',
      label: 'triangle',
      type: 'image',
      src: '/images/profiles/triangle.webp',
    },
  ];

  // 파일 선택 시
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file && validateVolumeFile(file)) {
      urlFilePreview.value = URL.createObjectURL(file);
      //   emit('file-selected', file);
    }
  };

  // 파일 크기 검증
  const validateVolumeFile = (file) => {
    if (file) {
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (file.size > maxSize) {
        toastStore.error(
          '파일 용량이 10MB를 초과합니다. 다른 파일을 선택해주세요.'
        );
        return false;
      }
      return true;
    }
  };

  // 파일을 드래그 앤 드롭 했을 시
  const handleFileDrop = (event) => {
    const file = event.dataTransfer.files[0];
    if (file) {
      handleFileSelect({ target: { files: [file] } });
    }
  };

  // 파일 선택 열기
  const triggerFileInput = () => {
    // fileInput.value.click();
  };

  // 파일 삭제
  const removeFile = () => {
    urlFilePreview.value = '';
  };
  return {
    urlFilePreview,
    listImageDefault,
    handleFileSelect,
    handleFileDrop,
    triggerFileInput,
    removeFile,
  };
}
